function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "a",
  x1: "100.037387%",
  x2: ".046733%",
  y1: "50.087931%",
  y2: "50.087931%"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M77 4c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M75 2l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M195 2c-3-1-7 0-10 1-4 2-9 2-13 0-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M195 0l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M50 14c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M49 12l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M116 12c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M116 10l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M37 22c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M37 20l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M182 24c-3 1-7 0-10-1-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M181 22l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M301 22c-4-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M301 20l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M380 22c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M380 20l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 34c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 32l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M261 34c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M260 32l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M354 32c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M354 30l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 34c-3 1-7 0-10-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 32l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 42c-4-1-8 0-11 1"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M10 40l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M77 44c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M75 42l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M222 42c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M222 40l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 44c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 42l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M50 54c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M49 52l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M182 54c-3 1-7 0-10-1-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M181 52l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M301 52c-4-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M301 50l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M380 52c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M380 50l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M103 64c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M102 62l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M235 64c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M234 62l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 64c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 62l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M24 74c-4 1-7 0-11-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M23 72l3 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M156 74c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M155 72l3 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M301 72c-4-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M301 70l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M354 72c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M354 70l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 74c-3 1-7 0-10-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 72l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M37 152c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M37 150l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 154c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 152l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M209 154c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M207 152l4 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M354 152c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0c-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M354 150l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 162c-4-1-8 0-11 1"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M10 160l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M77 164c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M75 162l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M169 162c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M169 160l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M248 162c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M248 160l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M143 172c-4-1-8 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M143 170l2 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M209 174c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M207 172l4 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M327 172c-3-1-7 0-10 1-4 2-9 2-13 0-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0c-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M327 170l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 174c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 172l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M37 182c-4-1-7 0-11 1-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M37 180l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M103 184c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M102 182l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M195 182c-3-1-7 0-10 1-4 2-9 2-13 0-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M195 180l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M275 182c-4-1-8 0-11 1-4 2-9 2-13 0s-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M275 180l2 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M354 182c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M354 180l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 184c-3 1-7 0-10-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 182l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M50 194c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M49 192l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M222 192c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M222 190l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M314 194c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-8 2-13 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M313 192l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M380 192c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M380 190l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M24 204c-4 1-7 0-11-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M23 202l3 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 204c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 202l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M195 202c-3-1-7 0-10 1-4 2-9 2-13 0-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M195 200l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M248 202c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M248 200l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M77 214c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M75 212l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M92 213c5 2 9 2 14 0s9-2 13 0 9 2 13 0 9-2 13 0 9 2 13 0 9-2 14 0c3 1 7 2 10 1"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M182 216l3-3-4-1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M327 212c-3-1-7 0-10 1-4 2-9 2-13 0-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M327 210l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 214c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 212l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M380 222c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0c-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M380 220l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M50 224c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M49 222l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 224c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 222l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M209 224c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M207 222l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 84c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 82l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M182 84c-3 1-7 0-10-1-5-2-9-2-14 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M181 82l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M261 84c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M260 82l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M380 162c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M380 160l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 92c-4-1-8 0-11 1"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M10 90l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M156 94c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M155 92l3 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M209 94c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M207 92l4 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M248 92c-3-1-7 0-10 1-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M248 90l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M367 204c-4 1-7 0-11-1-4-2-8-2-13 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M366 202l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 204c-3 1-7 0-10-1"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 202l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 154c-3 1-7 0-10-1-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 152l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M50 104c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M49 102l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M116 102c-3-1-7 0-10 1-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M116 100l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M90 112c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M90 110l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M235 14c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M234 12l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M341 14c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M339 12l4 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 14c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 12l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M37 122c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M37 120l3 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M103 124c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M102 122l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M314 4c-3 1-7 0-10-1-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M313 2l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 4c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 2l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M129 134c-3 1-7 0-10-1-4-2-9-2-13 0s-9 2-14 0c-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M128 132l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M288 134c-4 1-7 0-11-1-4-2-9-2-13 0s-9 2-13 0-9-2-13 0c-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M287 132l3 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M341 134c-4 1-8 0-11-1-4-2-9-2-13 0s-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M339 132l4 1-2 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 134c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 132l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M90 142c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0-4 2-9 2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M90 140l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M222 142c-4-1-7 0-11 1-4 2-9 2-13 0s-9-2-13 0-9 2-13 0c-5-2-9-2-14 0s-9 2-13 0-9-2-13 0-9 2-13 0-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M222 140l2 3-3 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M275 142c-4-1-8 0-11 1-4 2-9 2-13 0s-9-2-13 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M275 140l2 3-4 1z"
}), React.createElement("path", {
  stroke: "#145569",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M393 144c-3 1-7 0-10-1-4-2-9-2-13 0-5 2-9 2-14 0-4-2-9-2-13 0s-9 2-13 0-9-2-13 0-9 2-13 0c-5-2-9-2-14 0"
}), React.createElement("path", {
  fill: "#145569",
  fillRule: "nonzero",
  d: "M392 142l4 1-3 3z"
}), React.createElement("path", {
  stroke: "#46c3d7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M135 122v6M200 123v5l3-5",
  opacity: 0.5
}), React.createElement("g", {
  fillRule: "nonzero",
  className: "plane"
}, React.createElement("path", {
  fill: "url(#a)",
  d: "M310 108h4l85 2-85 1h-4l-18-1z",
  opacity: 0.6
}), React.createElement("path", {
  fill: "#fff",
  d: "M113 115l12-6c4-3 10-4 15-4h108l3-1c3-1 6-2 8-5l18-21 3-1h6a1 1 0 0 1 1 1l-7 28 9 2h1v3h-1l-28 8c-11 3-23 5-34 5h-78c-11 0-23-2-34-4-2 0-3-2-3-3l1-2z"
}), React.createElement("path", {
  fill: "#46c3d7",
  d: "M227 124h-78c-11 0-23-2-34-4-2 0-3-2-3-3l1-2 12-7c4-2 10-3 15-3h1c4 8 13 14 23 14h99-2c-11 3-23 5-34 5zM266 110l18-4h7l-9 4-1 1h-15l-1-1z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M259 99l8-9-2 4a9 9 0 0 0 6 12h-2l-21-1 3-1c3-1 6-2 8-5z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M126 112h-8l6-3h6z",
  opacity: 0.4
}), React.createElement("rect", {
  width: 4.69,
  height: 9.39,
  x: 133,
  y: 107,
  fill: "#145569",
  opacity: 0.4,
  rx: 1.85,
  transform: "rotate(180 135 112)"
}), React.createElement("rect", {
  width: 4.69,
  height: 9.39,
  x: 251,
  y: 107,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.85,
  transform: "rotate(180 253 112)"
}), React.createElement("rect", {
  width: 2.96,
  height: 5.06,
  x: 179,
  y: 109,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(180 180 112)"
}), React.createElement("rect", {
  width: 2.96,
  height: 5.06,
  x: 183,
  y: 109,
  fill: "#145569",
  opacity: 0.1,
  rx: 1.08,
  transform: "rotate(180 184 112)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 143,
  y: 110,
  fill: "#071920",
  rx: 0.52,
  transform: "rotate(180 143 111)"
}), React.createElement("path", {
  fill: "#46c3d7",
  d: "M145 111a1 1 0 0 1 1 0v1z"
}), React.createElement("path", {
  fill: "#071920",
  d: "M145 111l1 1-1-1z"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 148,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 148 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 150,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 151 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 153,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 153 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 155,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 156 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 158,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 158 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 161,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 161 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 163,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 164 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 166,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 166 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 168,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 169 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 171,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 171 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 173,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 174 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 176,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 176 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 180,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 180 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 184,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 184 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 188,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 188 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 190,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 191 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 193,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 193 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 196,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 196 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 198,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 199 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 201,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 201 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 203,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 204 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 206,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 206 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 208,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 209 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 211,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 211 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 213,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 214 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 216,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 216 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 219,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 219 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 221,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 222 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 224,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 224 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 226,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 227 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 229,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 229 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 231,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 232 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 234,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 234 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 236,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 237 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 239,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 239 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 242,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 242 111)"
}), React.createElement("rect", {
  width: 1.04,
  height: 1.54,
  x: 244,
  y: 110,
  fill: "#46c3d7",
  rx: 0.52,
  transform: "rotate(180 245 111)"
}), React.createElement("path", {
  fill: "#46c3d7",
  d: "M209 112c3-1 6-3 7-5l7-9 2-1h2v1l-6 11-3 3z"
}), React.createElement("path", {
  fill: "#071920",
  d: "M169 118l40-7h9l-26 10-8 1-15-1a1 1 0 0 1-1-2l1-1z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M186 126h-4v-7h17l-4 4-9 3z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M176 127h-6v-10h23v1l-6 5c-3 2-7 4-11 4z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M168 122c0-3 1-5 2-5s3 2 3 5-1 5-3 5-2-2-2-5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M170 121l1 1-1 1a1 1 0 1 1 0-2z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M289 108h-1v4l1-1h1v-3h-1z"
}), React.createElement("circle", {
  cx: 201.02,
  cy: 127.51,
  r: 1.5,
  fill: "#145569"
}), React.createElement("circle", {
  cx: 201.02,
  cy: 127.51,
  r: 1,
  fill: "#46c3d7"
}), React.createElement("circle", {
  cx: 199.02,
  cy: 127.51,
  r: 1.5,
  fill: "#145569"
}), React.createElement("circle", {
  cx: 199.02,
  cy: 127.51,
  r: 1,
  fill: "#46c3d7"
}), React.createElement("circle", {
  cx: 135.37,
  cy: 127.51,
  r: 1.5,
  fill: "#145569"
}), React.createElement("circle", {
  cx: 135.37,
  cy: 127.51,
  r: 1,
  fill: "#46c3d7"
})));

var SvgWind = function SvgWind(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    className: "wind",
    viewBox: "0 0 398 226",
    width: 414,
    height: 236,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWind, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wind.35e94842.svg";
export { ForwardRef as ReactComponent };